export default __webpack_public_path__ + "static/media/q7_step1.2245b2cb.png";